import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "aboutBg"
};
const _hoisted_2 = {
  class: "newsBg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Carousel = _resolveComponent("Carousel");
  const _component_ProductCenter = _resolveComponent("ProductCenter");
  const _component_AboutUs = _resolveComponent("AboutUs");
  const _component_Excellent = _resolveComponent("Excellent");
  const _component_NewsTrands = _resolveComponent("NewsTrands");
  const _component_Cooperation = _resolveComponent("Cooperation");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Carousel), _createVNode(_component_ProductCenter), _createElementVNode("div", _hoisted_1, [_createVNode(_component_AboutUs)]), _createVNode(_component_Excellent), _createElementVNode("div", _hoisted_2, [_createVNode(_component_NewsTrands)]), _createVNode(_component_Cooperation)], 64);
}